import { query, waitForAllReturnWhenError } from '@confluence/query-preloader-tools';
import { expVal } from '@confluence/feature-experiments';

import { PersistenceQuery } from './SpaceViewsPersistenceQueries.graphql';
import { SpaceRootQuery } from './SpaceViewsQueries.graphql';

export function preloadSpaceViews(spaceKey: string, isLicensed: boolean) {
	const queries: Promise<any>[] = [];
	if (!expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		queries.push(
			query({
				query: SpaceRootQuery,
				variables: {
					spaceKey,
				},
			}),
		);
	}

	if (isLicensed) {
		queries.push(
			query({
				query: PersistenceQuery,
				variables: {
					spaceKey,
				},
			}),
		);
	}
	return waitForAllReturnWhenError(queries);
}
